// Modules
import React, { useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import { Loading } from '@dasa-health/components-react'

// Application
import { TokenType } from 'typings/index'
import { TIME_FOR_ENABLE_RESEND_TOKEN } from 'constants/app'

// Components
import { Token } from './Token'
import { ResendToken } from './ResendToken'
import { StyledForm } from './styles'
import { SignUpModal } from 'redesign/components/molecules/SignUpModal'
import { SignUpHelpTextModal } from 'redesign/components/atoms/SignUpHelpTextModal'

export interface ValidateTokenInitial {
    token: TokenType
}

interface Props {
    initialValues: ValidateTokenInitial
    handleSubmit: (values: { token: TokenType }) => Promise<void>
    handleResendToken: () => Promise<void>
    isDestinationMobile: boolean
    isSubmitting: boolean
    isLoading: boolean
    fieldState: {
        status: string
        message: string
    }
}

export const ValidateToken: React.FC<Props> = props => {
    const { handleSubmit, fieldState, initialValues, handleResendToken, isLoading, isDestinationMobile } = props
    const [counter, setCounter] = useState(TIME_FOR_ENABLE_RESEND_TOKEN)
    const [showModal, setShowModal] = useState(false)
    const [showCounter, setShowCounter] = useState(true)

    useEffect(() => {
        let unmount = false
        let counterTimer: ReturnType<typeof setTimeout>
        if (counter > 0) {
            counterTimer = setTimeout(() => {
                if (!unmount) {
                    setCounter(counter - 1)
                }
            }, 1000)
        }

        if (counter === 0) {
            setShowCounter(false)
        }

        return () => {
            unmount = true
            clearTimeout(counterTimer)
        }
    }, [counter, fieldState])

    const onResendToken = async () => {
        await handleResendToken()
        setCounter(TIME_FOR_ENABLE_RESEND_TOKEN)
        setShowCounter(true)
    }

    const getClassByStatus = (status: string) =>
        status ? `validate-form__field validate-form__field--${status}` : 'validate-form__field'

    return (
        <Formik initialValues={initialValues} onSubmit={values => handleSubmit(values)}>
            {({ values, setFieldValue, submitForm }) => (
                <StyledForm>
                    <SignUpModal
                        setShowModal={() => {
                            setShowModal(!showModal)
                        }}
                        showModal={showModal}
                        title="Por que preciso fazer isso?"
                    >
                        <p>
                            Ao entrar no Nav Dasa, você poderá acessar todo o seu histórico de saúde e dados pessoais coletados no
                            ecossistema Dasa.
                        </p>
                        <p>
                            Através deste código, posso verificar sua identidade e garantir que o acesso às suas informações está
                            seguro.
                        </p>
                    </SignUpModal>
                    <SignUpHelpTextModal onClick={() => setShowModal(true)}>Por que preciso fazer isso?</SignUpHelpTextModal>
                    <Form autoComplete="one-time-code">
                        <Token
                            fieldState={fieldState}
                            getClassByStatus={getClassByStatus}
                            isSubmitting={isLoading}
                            setFieldValue={setFieldValue}
                            submitForm={submitForm}
                            values={values}
                        />
                        <footer className="form__validate-form__footer">
                            {isLoading ? (
                                <Loading data-testid="loading-test" size={35} strokeWidth={4} />
                            ) : (
                                <ResendToken
                                    count={counter}
                                    dataTestButton={'resend-token'}
                                    dataTestCounter={'counter-test'}
                                    isCounter={showCounter}
                                    isDestinationMobile={isDestinationMobile}
                                    onResendToken={onResendToken}
                                />
                            )}
                        </footer>
                    </Form>
                </StyledForm>
            )}
        </Formik>
    )
}
